<template>
  <DynamicDialog />
  <ConfirmDialog />
</template>

<script setup lang="ts">
import DynamicDialog from "primevue/dynamicdialog";
import ConfirmDialog from "primevue/confirmdialog";
import { useDialog } from "primevue/usedialog";
import { onMounted } from "vue";
import { useGlobalDialog } from "@/components/globalDialogService/useGlobalDialog";

const dialog = useDialog();

onMounted(() => {
  useGlobalDialog(dialog);
});
</script>

<style scoped lang="scss"></style>
